import axios from "axios";

const instance = axios.create();

instance.defaults.headers.post["Content-Type"] = "application/json";
instance.defaults.timeout = 1000 * 30;

// request interceptor
instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// response interceptor
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // console.log(error.response.data,'error.response')
    // if (error.response && error.response.status === 401) {
      // alert("Your session has expired. Click OK to login again.");
      // localStorage.clear();
      // window.location.reload();
    // }
    return Promise.reject(error?.response?.data);
  },
);

export default instance;
